export function CompareArrays(a1, a2) {
  // Fail if length isn't the same
  if (a1.length != a2.length) return false;
  // Sort the arrays
  a1.sort();
  a2.sort();
  for (var i = 0; i < a1.length; i++) {
    // Fail if items don't match
    if (a1[i] !== a2[i]) return false;
  }
  return true;
}
